import { I18nFormatter } from '../I18n/I18n';
import store from '../../stores/redux';

const Money = {
    toFixedRatio(number, currency, format = false) {
        const currencyData = store.getState().currency.list.find((item) => item.name === currency) || {};
        const capacity = (currencyData.subunit || 0) + 4;
        const rounder = Math.pow(10, capacity);
        let value = parseInt(number * rounder) / rounder;

        if (format) {
            let params = {
                minimumFractionDigits: capacity,
                maximumFractionDigits: capacity
            };

            value = I18nFormatter.int(value, params);
        }

        return value;
    }
};

export default Money;
